import { getTask, getTasksList } from "blackswan-api";

export const getTodayTasks = (
    setLoaded: (loaded: boolean) => void,
    setTasks: (tasks: any[]) => void
) =>
    getTasksList(({ data }: { data: any }) => {
        setLoaded(true);
        if (Array.isArray(data)) {
            setTasks(data);
        }
    });

export const getTaskById = (
    id: number | string,
    setTaskModalVisible: (visible: boolean) => void,
    setTaskForm: (task: any) => void
) =>
    getTask(id, ({ data }: { data: any }) => {
        setTaskModalVisible(true);
        setTaskForm(data);
    });
